<template>
  <ui-modal-layout :title="tr('Would you like to turn on the campaign too?')" :icon="StatusIcon">
    <div class="flex flex-col gap-3 text-muted-foreground">
      <p class="m-0">{{ tr('The campaign is currently inactive, in which the desired automation is being worked to be turned on.') }}</p>
      <p class="m-0">{{ tr('Turning on automation also entails reactivating the campaign, thus the existing advertisements within it will become active again.') }}</p>
    </div>

    <template #footer>
      <ui-button :disabled="isLoading" @click="() => confirm()">
        <loader-circle-icon v-if="isLoading" class="animate-spin" />
        {{ tr('Turn on Automation and Campaign') }}
      </ui-button>
    </template>
  </ui-modal-layout>
</template>

<script>
import { LoaderCircle, Power } from '@lucide/vue';
import { markRaw } from 'vue';

import Rule from '@/entities/Rule';
import RuleService from '@/services/Rule.js';

export default {
  name: 'RuleCampaignStatusChangeModalContent',
  components: {
    LoaderCircleIcon: LoaderCircle,
  },
  props: {
    rule: {
      type: Rule,
      required: true,
    },
  },
  data: () => ({
    StatusIcon: markRaw(Power),
    loadingRule: false,
    isLoading: false,
  }),
  computed: {
    id() {
      return this.rule.id;
    },
    newStatus() {
      return !this.rule.active;
    },
  },
  methods: {
    close() {
      this.$fullscreenModal.closeAll();
    },
    confirm() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;

      RuleService.changeStatus(this.id, this.newStatus, true)
        .then(rule => this.onSuccess(rule))
        .catch(err => {
          this.error(err);
          this.rule.active = !this.newStatus;
        })
        .finally(() => this.isLoading = false);
    },
    onSuccess(newValues) {
      this.rule.updateWith(newValues);
      this.close();
    },
  },
};
</script>
